define('lazy-loader',['event-manager'], function(eventManager) {
    'use strict';

    function defaultCallback(element) {
        var comment = null;

        for (var i = element.childNodes.length; --i >= 0;){
            if (element.childNodes[i].nodeType === 8) {
                comment = element.childNodes[i];
            }
        }

        if (comment !== null) {
            var el = document.createElement('div'),
                id = element.getAttribute('id'),
                html = comment.nodeValue,
                style = element.getAttribute('data-lazy-style');

            el.innerHTML = html;

            el = el.childNodes[0];
            if (style) {
                el.setAttribute('style',  style);
            }

            element.parentNode.replaceChild(el, element);
            if (id) {
                eventManager.emit('lazy-'+ id + '-loaded', el);
            }

            eventManager.emit('lazy-loaded-element', el);
        }
    }

    var LazyLoader = function(params) {
        this.options = {
            threshold: params.threshold || 100,
            aboveTheFold: params.aboveTheFold || false,
            callback: params.callback || defaultCallback
        };

        var wrappedCallback = function(entries) {
            for (var i = 0; i < entries.length; i++) {
                var entry = entries[i];
                if (entry.isIntersecting) {
                    this.observer.unobserve(entry.target);

                    this.options.callback(entry.target);
                }
            }
        };
        wrappedCallback = wrappedCallback.bind(this);

        var elems = params.on;
        if (!Array.isArray(elems)) {
            elems = [elems];
        }

        var above = this.options.aboveTheFold ? 10000 : this.options.threshold;

        var options = {
            rootMargin: above + "px 0px " + this.options.threshold + "px 0px",
        };

        this.observer = new IntersectionObserver(wrappedCallback, options);
        for (var i = 0; i < elems.length; i++) {
            this.observer.observe(elems[i]);
        }
    };

    LazyLoader.prototype = {
        detach: function() {
            this.observer.disconnect();
        },
    };

    return LazyLoader;
});

